import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import { toast } from 'sonner';
import AddAdmissionType from './AddAdmissionType';
import AdmissionType from './AdmissionType';
import ViewAdmissionType from './ViewAdmissionType';
import EditAdmissionType from './EditAdmissionType';

const ProtectedRoute = ({ element, permission, fallbackPath = '/' }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!permission) {
      toast.warning("You don't have permission to access this page.");
      navigate("/dashboard/admission-type", { replace: true });
    }
  }, [permission, navigate, fallbackPath]);

  return permission ? element : null;
};

const MainAdmissionType = () => {
  const User = JSON.parse(localStorage.getItem("User") || "{}");
  const Permission = User?.userRole?.permissions || {};

  return (
    <div className='bg-gray-100 text-gray-900 px-4 dark:bg-gray-900 dark:text-white'>
      <Routes>
        <Route path='/' element={<AdmissionType />} />

        <Route 
          path='/add-admission-type' 
          element={<ProtectedRoute element={<AddAdmissionType />} permission={Permission.master?.create} fallbackPath="/" />}
        />

        <Route 
          path='/view-admission-type' 
          element={<ProtectedRoute element={<ViewAdmissionType />} permission={Permission.master?.read} fallbackPath="/" />}
        />

        <Route 
          path='/edit-admission-type' 
          element={<ProtectedRoute element={<EditAdmissionType />} permission={Permission.master?.update} fallbackPath="/" />}
        />
      </Routes>
    </div>
  );
};

export default MainAdmissionType;
